const obj = {
    pageDistributorTypes:"/platform/distributorType/pageDistributorTypes",     //分页查询分销商渠道信息
    getDistributorType:"/platform/distributorType/info/",   //获取分销商渠道信息
    distributorTypeSave:"/platform/distributorType/save",   //保存分销商渠道信息
    distributorTypeUpdate:"/platform/distributorType/update",   //更新分销商渠道信息

    getPrivilege:"/platform/distributorType/privilege/info/",   //根据分销商渠道Id获取渠道权益信息
    delDistributorType:"/platform/distributorType/policy/delete/",  //"根据渠道政策Id删除政策信息"
    privilegeSave:"/platform/distributorType/privilege/save",   //保存渠道商权益信息

    listDistributorItemTags:"/distributorConfig/listDistributorItemTags",  //获取分销商可售品类集合
}
export default obj;